import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { totalBudget } from '../../util/api';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/ModernLandingPage/SET_INITIAL_STATE';

export const QUERY_LISTINGS_REQUEST = 'app/ModernLandingPage/QUERY_LISTINGS_REQUEST';
export const QUERY_LISTINGS_SUCCESS = 'app/ModernLandingPage/QUERY_LISTINGS_SUCCESS';
export const QUERY_LISTINGS_ERROR = 'app/ModernLandingPage/QUERY_LISTINGS_ERROR';

export const GET_BUDGET_REQUEST = 'app/ModernLandingPage/GET_BUDGET_REQUEST';
export const GET_BUDGET_SUCCESS = 'app/ModernLandingPage/GET_BUDGET_SUCCESS';
export const GET_BUDGET_ERROR = 'app/ModernLandingPage/GET_BUDGET_ERROR';

const listingsPerPage = 10;

// ================ Reducer ================ //

const initialState = {
    listingRefs: [],
    queryListingsInProgress: false,
    queryListingsError: null,

    budgetDetails: {},
    getBudgetInProgress: false,
    getBudgetError: null,
};

export default function modernLandingPageReducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case SET_INITIAL_STATE:
            return { ...initialState };

        case QUERY_LISTINGS_REQUEST:
            return {
                ...state,
                listingRefs: [],
                queryListingsInProgress: true,
                queryListingsError: null,
            };
        case QUERY_LISTINGS_SUCCESS:
            return { ...state, listingRefs: payload.listingRefs, queryListingsInProgress: false };
        case QUERY_LISTINGS_ERROR:
            return { ...state, listingRefs: [], queryListingsError: payload, queryListingsInProgress: false };

        case GET_BUDGET_REQUEST:
            return {
                ...state,
                getBudgetInProgress: true,
                getBudgetError: null,
            };
        case GET_BUDGET_SUCCESS:
            return { ...state, budgetDetails: payload, getBudgetInProgress: false };
        case GET_BUDGET_ERROR:
            return { ...state, getBudgetError: payload, getBudgetInProgress: false };
        default:
            return state;
    }
}

// ================ Action creators ================ //

export const setInitialState = () => ({
    type: SET_INITIAL_STATE,
});

export const queryListingsRequest = () => ({
    type: QUERY_LISTINGS_REQUEST,
});

export const queryListingsSuccess = listingRefs => ({
    type: QUERY_LISTINGS_SUCCESS,
    payload: { listingRefs },
});

export const queryListingsError = e => ({
    type: QUERY_LISTINGS_ERROR,
    error: true,
    payload: e,
});

export const getBudgetRequest = () => ({
    type: GET_BUDGET_REQUEST,
});

export const getBudgetSuccess = data => ({
    type: GET_BUDGET_SUCCESS,
    payload: data,
});

export const getBudgetError = e => ({
    type: GET_BUDGET_ERROR,
    error: true,
    payload: e,
});

// ================ Thunks ================ //

export const queryListings = () => (dispatch, getState, sdk) => {
    dispatch(queryListingsRequest());

    const queryParams = {
        perPage: listingsPerPage,
        include: ['author'],
    };

    const isCarsVariant = typeof window !== "undefined" && location?.pathname == "/cars";
    const isRealEstateVariant = typeof window !== "undefined" && location?.pathname == "/re";

    if (isCarsVariant) {
        queryParams.pub_categoryLevel1 = "cars";
    } else if (isRealEstateVariant) {
        queryParams.pub_categoryLevel1 = "comm_re,resi_re";
    };

    return sdk.listings
        .query({
            pub_listingType: "sell",
            ...queryParams,
        })
        .then(response => {
            const sellListingRefs = response.data.data.map(({ id, type }) => ({ id, type }));
            dispatch(addMarketplaceEntities(response));

            return sellListingRefs;
        })
        .then((sellListingRefs) => {
            return sdk.listings
                .query({
                    pub_listingType: "search",
                    ...queryParams,
                })
                .then(response => {
                    const searchListingRefs = response.data.data.map(({ id, type }) => ({ id, type }));
                    dispatch(addMarketplaceEntities(response));

                    const listingRefs = [...sellListingRefs, ...searchListingRefs];
                    dispatch(queryListingsSuccess(listingRefs));
                })
                .catch(e => dispatch(queryListingsError(storableError(e))));
        })
        .catch(e => dispatch(queryListingsError(storableError(e))));
};

export const getBudgetDetails = () => (dispatch, getState, sdk) => {
    dispatch(getBudgetRequest());

    return totalBudget({})
        .then(res => {
            dispatch(getBudgetSuccess(res));
        })
        .catch((e) => {
            dispatch(getBudgetError(storableError(e)))
        });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
    dispatch(setInitialState());
    // The total budget comes from our own API through a browser-only helper
    // (apiBaseUrl reads window), so it is fetched in the browser only. On the
    // server it threw and made the whole server-side data load fail, so the
    // home page's first HTML came without its listings.
    if (typeof window !== 'undefined') {
        dispatch(getBudgetDetails());
    }
    return dispatch(queryListings());
};
